<template>
  <div class="login-shell">
    <section class="login-introduction">
      <button type="button" class="login-brand" @click="home">
        <span class="login-brand__mark"><v-icon color="white">school</v-icon></span>
        <span class="login-brand__name">taleem<span>.app</span></span>
      </button>
      <div class="login-introduction__content">
        <div class="login-eyebrow">Masjid administration</div>
        <h1>Get back to your community.</h1>
        <p>Reset your password securely and return to your Taleem workspace.</p>
        <div class="login-feature">
          <v-icon>check_circle</v-icon>
          <span>Simple, secure, and built for your community</span>
        </div>
      </div>
    </section>

    <v-card class="login-card" elevation="0">
      <div class="login-card__heading">
        <div class="login-card__icon"><v-icon>lock_reset</v-icon></div>
        <div>
          <div class="login-eyebrow">Account recovery</div>
          <h2>Forgot your password?</h2>
          <p>Enter your organization code and admin account email. We'll send you a link to set a new password.</p>
        </div>
      </div>

      <v-card-text class="login-card__body">
        <form class="auth-recovery-form" novalidate @submit.prevent="submit">
          <v-text-field
            v-model.trim="code"
            :error-messages="codeErrors"
            :hide-details="codeErrors.length === 0"
            label="Organization code"
            prepend-inner-icon="business"
            autocomplete="organization"
            outlined
            class="login-field"
            @blur="$v.code.$touch()"
          />
          <v-text-field
            v-model.trim="emailAddress"
            :error-messages="emailErrors"
            :hide-details="emailErrors.length === 0"
            label="Email address"
            prepend-inner-icon="email"
            autocomplete="email"
            type="email"
            outlined
            class="login-field"
            @blur="$v.emailAddress.$touch()"
          />
          <v-btn :loading="loading" class="login-submit" color="primary" depressed block large type="submit">
            Send reset link <v-icon right>arrow_forward</v-icon>
          </v-btn>
        </form>
        <p v-if="requestError" class="auth-status auth-status--error" role="alert">{{ requestError }}</p>
      </v-card-text>

      <div class="login-card__signup">
        <button type="button" @click="$router.push('/login')">Back to sign in</button>
      </div>
    </v-card>
  </div>
</template>

<script>
import authService from '../service'
const { validationMixin } = require('vuelidate')
const { required, email } = require('vuelidate/lib/validators')

export default {
  name: 'authentication-forgot-password',
  mixins: [validationMixin],
  data() {
    return { code: '', emailAddress: '', loading: false, requestError: '' }
  },
  created() {
    this.code = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`) || ''
  },
  validations: { code: { required }, emailAddress: { required, email } },
  computed: {
    codeErrors() {
      const errors = []
      if (this.$v.code.$dirty && !this.$v.code.required) errors.push('Organization code is required.')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.emailAddress.$dirty) return errors
      if (!this.$v.emailAddress.required) errors.push('Email is required.')
      else if (!this.$v.emailAddress.email) errors.push('Enter a valid email address.')
      return errors
    },
  },
  methods: {
    home() { window.open('https://taleem.com', '_self') },
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid || this.loading) return
      this.loading = true
      this.requestError = ''
      try {
        const response = await authService.forgotPassword({ code: this.code, email: this.emailAddress })
        sessionStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}adminRecovery`, JSON.stringify({
          code: this.code,
          email: response.data.email,
          sentAt: Date.now(),
          retryAfterSeconds: response.data.retryAfterSeconds,
        }))
        this.$router.push({ name: 'recovery-email-sent' })
      } catch (error) {
        this.requestError = (error && error.data && error.data.message) || 'Unable to send the reset link. Please try again.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
